export default {
  currentGeolocation: {},
};
